<template>
  <v-dialog v-model="myValue" persistent max-width="960">
    <v-card>
      <v-card-title class="headline">结算确认</v-card-title>
      <v-card-text>
        <v-row style="margin-top: 50px" justify="center" no-gutters>
          <v-col cols="auto" class="text-h4">结算确认单</v-col>
        </v-row>
        <v-row style="margin-top: 50px" justify="start" no-gutters class="px-5">
          <v-col cols="12" style="text-indent: 2rem" class="text-subtitle-1">{{
            desc
          }}</v-col>
        </v-row>
        <v-row
          style="margin-top: 24px"
          justify="center"
          no-gutters
          class="px-5"
        >
          <v-col cols="auto" class="text-subtitle-1">
            <table
              style="border-collapse: collapse; cellspacing: 0; cellpadding: 0"
            >
              <tbody>
                <tr>
                  <td class="pa-4" :style="tdl">合同编号</td>
                  <td class="pa-4" :style="tdr">{{ myData.htbh }}</td>
                </tr>
                <tr>
                  <td class="pa-4" :style="tdl">项目名称</td>
                  <td class="pa-4" :style="tdr">{{ myData.xmmc }}</td>
                </tr>
                <tr>
                  <td class="pa-4" :style="tdl">项目编号</td>
                  <td class="pa-4" :style="tdr">{{ myData.xmfah }}</td>
                </tr>
                <tr>
                  <td class="pa-4" :style="tdl">样本数量</td>
                  <td class="pa-4" :style="tdr">{{ myData.ybsl }}</td>
                </tr>
                <tr>
                  <td class="pa-4" :style="tdl">账单金额</td>
                  <td class="pa-4" :style="tdr">{{ money }}</td>
                </tr>
                <tr>
                  <td class="pa-4" :style="tdl">检验完成</td>
                  <td class="pa-4" :style="tdr">{{ Utility.fmtTime(myData.testfinishdate) }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
        <v-row
          style="margin-top: 32px"
          justify="center"
          no-gutters
          class="px-5"
        >
          <v-col cols="auto" class="text-subtitle-1 red--text">
            备注：请前往余样回收确认剩余样本是否要寄回，按照合同约定检测完成三个月之后将自动销毁，请知悉！
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="darken-1" @click="myValue = false">关闭</v-btn>
        <v-btn color="primary darken-1" @click="onRefOk">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcConfirmReport, asgLtcProjectDetail } from "@/plugins/api";
import { asg } from "@/plugins/chart";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRefOk() {
      const params = {
        projectNos: [this.myData.xmfah],
        previewConfirm: 1
      };
      asgLtcConfirmReport(params).then(() => {
        this.$emit("query");
        this.$message.success("报告确认中，稍后请至项目列表页查看确认结果");
        this.myValue = false;
      });
    },
    getProjectDetail() {
      const params = {
        projectNo: this.myData.xmfah,
      };
      asgLtcProjectDetail(params).then((res) => (this.detail = res.data));
    },
  },
  data() {
    return {
      tdr: {
        border: "1px solid #000000",
        width: "200px",
        "box-sizing": "border-box",
      },
      detail: {},
      asg,
    };
  },
  computed: {
    myData() {
      return this.data;
    },
    myValue: {
      get() {
        if (this.value) {
          this.getProjectDetail();
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    tdl() {
      return {
        ...this.tdr,
        "background-color": "#fafafa",
      };
    },
    desc() {
      return `您的项目“${this.myData.htbh}+${this.myData.xmmc}技术服务合同”本次${this.myData.ybsl}个样本的${this.myData.csj}产品现已完成并满足结算要求，需要您确认此次服务金额（详情见如下表格）。在款项充足的条件下，我司将在结算确认后安排完整报告，交互分析和原始数据的释放，且此后项目进入售后阶段。`;
    },
    money() {
      return `${this.detail.mny} 元`;
    },
    xmzt() {
      return asg.projectStatus.find((item) => item.value == this.detail.xmzt)
        ?.name;
    },
  },
  watch: {},
  created() {},
};
</script>
